<template>
    <div class="vue-treeselect__value-container">
        <div v-if="instance.hasValue && !instance.trigger.searchQuery" class="vue-treeselect__single-value">
            <template v-if="instance.$slots['value-label']">
                <component :is="instance.$slots['value-label']" v-bind="{ node: instance.selectedNodes[0] }" />
            </template>
            <template v-else>
                {{instance.selectedNodes[0].label}}
            </template>
        </div>
        <Placeholder />
        <Input ref="input" />
    </div>
</template>

<script>
import Input        from './Input.vue'
import Placeholder  from './Placeholder.vue'

export default
{
    name        : 'Treeselect--single-value',
    inject      : [ 'instance' ],
    components  : { Input, Placeholder },
    methods     :
    {
        /*
        renderSingleValueLabel()
        {
            const { instance } = this;

            const node = instance.selectedNodes[0];

            const customValueLabelRenderer = instance.$slots['value-label'];

            return customValueLabelRenderer ? customValueLabelRenderer({ node }) : node.label;
        }
        */
    },

    /*
    render()
    {
        const { instance, $parent: { renderValueContainer } } = this;

        const shouldShowValue = instance.hasValue && !instance.trigger.searchQuery;

        return renderValueContainer([ shouldShowValue && ( <div class="vue-treeselect__single-value">{ this.renderSingleValueLabel() }</div> ), <Placeholder />, <Input ref="input" /> ])
    },
    */
}
</script>
